import {
  GET_MANUAL_GOLF_COACHES,
  GET_MANUAL_GOLF_COACHES_SUCCESS,
  GET_MANUAL_GOLF_COACHES_ERROR,
  GET_MANUAL_GOLF_COACHES_EMPTY,
} from '../../actions.js';

const initialState = { data: null, loading: false, error: null };

const GetManualGolfCoaches = (state = initialState, action) => {
  switch (action.type) {
    case GET_MANUAL_GOLF_COACHES:
      return { ...state, loading: true, data: null, error: null };
    case GET_MANUAL_GOLF_COACHES_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case GET_MANUAL_GOLF_COACHES_ERROR:
      return { ...state, loading: false, error: action.payload };
    case GET_MANUAL_GOLF_COACHES_EMPTY:
      return { ...initialState };
    default:
      return state;
  }
};

export default GetManualGolfCoaches;
